var NUM_PRODUCTS_OPTIONS = function(strictLocalize) {
    return [
        {
            label: strictLocalize({
                id: "vYjHpC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "I do not currently sell wholesale products"
                    }
                ]
            }),
            value: 0
        },
        {
            label: strictLocalize({
                id: "O9UGZ9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "1-10"
                    }
                ]
            }),
            value: 10
        },
        {
            label: strictLocalize({
                id: "GNPfvF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "11-25"
                    }
                ]
            }),
            value: 25
        },
        {
            label: strictLocalize({
                id: "OPwQyA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "26-50"
                    }
                ]
            }),
            value: 50
        },
        {
            label: strictLocalize({
                id: "EUMXze",
                defaultMessage: [
                    {
                        type: 0,
                        value: "51-100"
                    }
                ]
            }),
            value: 100
        },
        {
            label: strictLocalize({
                id: "C4lX/k",
                defaultMessage: [
                    {
                        type: 0,
                        value: "More than 100"
                    }
                ]
            }),
            value: 101
        }
    ];
};
export var NUM_PRODUCTS_IOPTIONS = function(strictLocalize) {
    return NUM_PRODUCTS_OPTIONS(strictLocalize).map(function(option) {
        return {
            label: option.label,
            value: option.value.toString()
        };
    });
};
